// Session timeout management - 15 minutes of inactivity

const TIMEOUT_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds
const WARNING_TIME = 14 * 60 * 1000; // Show warning at 14 minutes

class SessionManager {
  constructor() {
    this.timeoutId = null;
    this.warningId = null;
    this.onWarning = null;
    this.onTimeout = null;
    this.isActive = false;
  }

  start(onWarning, onTimeout) {
    this.onWarning = onWarning;
    this.onTimeout = onTimeout;
    this.isActive = true;
    this.resetTimer();
    this.attachEventListeners();
  }

  stop() {
    this.isActive = false;
    this.clearTimers();
    this.removeEventListeners();
  }

  resetTimer() {
    if (!this.isActive) return;

    this.clearTimers();

    // Set warning timer (14 minutes)
    this.warningId = setTimeout(() => {
      if (this.onWarning && this.isActive) {
        this.onWarning();
      }
    }, WARNING_TIME);

    // Set timeout timer (15 minutes)
    this.timeoutId = setTimeout(() => {
      if (this.onTimeout && this.isActive) {
        this.onTimeout();
      }
    }, TIMEOUT_DURATION);
  }

  clearTimers() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (this.warningId) {
      clearTimeout(this.warningId);
      this.warningId = null;
    }
  }

  attachEventListeners() {
    // Events that indicate user activity
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
      window.addEventListener(event, this.handleActivity);
    });
  }

  removeEventListeners() {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
      window.removeEventListener(event, this.handleActivity);
    });
  }

  handleActivity = () => {
    this.resetTimer();
  }

  extendSession() {
    this.resetTimer();
  }
}

// Create singleton instance
const sessionManager = new SessionManager();

export default sessionManager;
